import React, { useState, useEffect, useContext } from 'react'
import {
  CCard,
  CCardBody,
  CCardHeader,
  CForm,
  CFormLabel,
  CFormInput,
  CRow,
  CCol,
  CFormSelect,
  CButton,
} from '@coreui/react'
import PropTypes from 'prop-types'
import { UserContext } from 'src/context/UserContext'
import { KaryalayaAPI } from './KaryalayaAPI'
import { CircularProgress } from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import { CONSTANTS } from 'src/constants'
import { convert_to_preeti } from 'src/helpers/PreetiConverter'

const initialState = {
  name: '',
  province: 1,
  status: 1,
  slug: null,
}

const KaryalayaForm = ({
  open,
  editMode,
  handleClose,
  editData,
  reload,
  setReload,
  fetching,
  selectedId,
}) => {
  // Response State
  const [response, setResponse] = useState({
    success: null,
    error: null,
  })
  // Karyalaya data
  const [karyalayaData, setKaryalayaData] = useState(initialState)

  // Lifecycle method to
  useEffect(() => {
    // console.log(editData)
    if (editData) {
      setKaryalayaData({
        name: editData.name,
        province: editData.province,
        slug: editData.slug,
        status: editData.status,
      })
    }
  }, [editData])

  useEffect(() => {
    if (open === false) {
      setResponse({
        success: null,
        error: null,
      })
    }
  }, [open])
  // User Context
  const [user] = useContext(UserContext)

  const [loading, setLoading] = useState(false)

  // function to handle karyalaya data changes
  const handleKaryalayaDataChange = (e) => {
    setKaryalayaData({ ...karyalayaData, [e.target.name]: convert_to_preeti(e.target.value) })
  }

  // Function to create Karyalaya
  const handleSubmit = (e) => {
    e.preventDefault()
    if (karyalayaData.name === '') {
      return
    }
    setLoading(true)

    {
      editMode
        ? KaryalayaAPI.editKaryalaya(user.access_token, karyalayaData, selectedId)
            .then((res) => {
              if (res.data.status === true) {
                setKaryalayaData(initialState)
                setResponse({
                  error: null,
                  success: 'Karyalaya has been updated',
                })
                setLoading(false)
              } else {
                console.log(res.data)
                setResponse({
                  error: 'Failed to update',
                  success: null,
                })
                setLoading(false)
              }
            })
            .catch((e) => console.log(e.message))
        : KaryalayaAPI.createKaryalaya(user.access_token, karyalayaData)
            .then((res) => {
              if (res.data.status === true) {
                setLoading(false)
                setKaryalayaData(initialState)
                setResponse({
                  error: null,
                  success: 'New Karyalaya has been created',
                })
                setReload(!reload)
              }
            })
            .catch((e) => console.log(e.message))

      setTimeout(
        () =>
          setResponse({
            success: null,
            error: null,
          }),
        CONSTANTS.ALERT_TIME_OUT,
      )
    }
  }

  return (
    <CCard className="mb-4">
      <CCardHeader>{editMode ? 'Edit Karyalaya' : 'नयाँ कार्यालय'}</CCardHeader>
      <CCardBody>
        {response.success ? <Alert severity="success">{response.success}</Alert> : null}
        {response.error ? <Alert severity="error">{response.error}</Alert> : null}

        {fetching ? (
          <CircularProgress />
        ) : (
          <CForm className={response.success || response.error ? 'mt-4' : null}>
            <CRow>
              <CCol md="12">
                <div className="mb-3">
                  <CFormLabel htmlFor="karyalayaName">कार्यालय को नाम</CFormLabel>

                  <CFormInput
                    type="text"
                    id="karyalayaName"
                    placeholder=""
                    name="name"
                    value={karyalayaData.name}
                    onChange={handleKaryalayaDataChange}
                    // onKeyUp={conversion}
                  />
                </div>
              </CCol>

              <CCol md="12">
                {loading ? (
                  <CircularProgress />
                ) : (
                  <CButton type="submit" color="primary" size="sm" onClick={handleSubmit}>
                    {editMode ? 'Save' : 'कार्यालय बनाउनुहोस'}
                  </CButton>
                )}
                &nbsp;{' '}
                {editMode ? (
                  <CButton color="danger" size="sm" variant="outline" onClick={handleClose}>
                    Close
                  </CButton>
                ) : null}
              </CCol>
            </CRow>
          </CForm>
        )}
      </CCardBody>
    </CCard>
  )
}

export default KaryalayaForm

KaryalayaForm.propTypes = {
  editMode: PropTypes.bool,
  handleClose: PropTypes.func,
}

KaryalayaForm.defaultProps = {
  editMode: false,
  handleClose: () => console.log('Clicked'),
}
